import EcoImg from 'eco-design/base/eco-img';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const IMG = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767840235619-jevxb1-compressed-full-width-carousel.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767842633178-eg08sp-compressed-Frame%202094654778.jpg',
    },
    za: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1789350379469-r9ycm6-compressed-full-width-carousel.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1789350391123-iodc9w-compressed-Frame%202094654778.webp',
    },
};

function TheComp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();
    const img = IMG[locale as keyof typeof IMG] || IMG.us;

    useOnceInView('.on-the-road-F .F-title', () => {
        document.querySelector('.F-title')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-F GtmModuleData-section`}
            id="on-the-road-F"
            data-section-id={'on-the-road-F'}
            data-section-title={t('F_title')}
        >
            <EcoImg pc={img.pc} h5={img.h5} isOpenLazy />
            <div className="F-title ani-1">{t('F_title')}</div>
        </section>
    );
}

export default TheComp;
